import { publicAssetUrl } from './brand';

export type ProductVideo = {
  id: string;
  title: string;
  description: string;
  /** YouTube video id when available (privacy-enhanced embed). */
  youtubeId?: string;
  /** Self-hosted mp4 under /public. */
  mp4Src?: string;
  posterSrc?: string;
};

/**
 * Primary MSME UX GUI demo on the pre-login homepage.
 * Last 5 seconds trimmed from the recorded walkthrough.
 */
export const HOMEPAGE_PRODUCT_VIDEO: ProductVideo = {
  id: 'msme-ux-demo',
  title: 'MSME plain-language UX demo',
  description:
    'See how an MSME owner taps Scope 1–3 for picture-backed explanations, switches English/Hindi, and follows the 4-step workflow — no ESG jargon required.',
  mp4Src: publicAssetUrl('/videos/msme-plain-language-ux-demo.mp4'),
  posterSrc: publicAssetUrl('/videos/msme-plain-language-ux-demo-poster.jpg'),
};

/** No duplicate chapter cards — homepage shows a single demo video. */
export const PRODUCT_VIDEOS: ProductVideo[] = [];

export const PRODUCT_VIDEOS_SECTION = {
  id: 'product-videos',
  title: 'See Carbon Intelligence in action',
  subtitle:
    'Watch the MSME UX walkthrough: plain-language explainers, Hindi toggle, and the 4-step path from bills to report-ready. Book a live demo if you want a walkthrough with your data.',
  demoEmail: 'contact@sustainow.in',
  demoLabel: 'Book a live demo',
} as const;
